import { render, staticRenderFns } from "./Opt.vue?vue&type=template&id=7b264e9c&scoped=true"
import script from "./Opt.vue?vue&type=script&lang=js"
export * from "./Opt.vue?vue&type=script&lang=js"
import style0 from "./Opt.vue?vue&type=style&index=0&id=7b264e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b264e9c",
  null
  
)

export default component.exports